<img [src]="useDarkMode() ? 'assets/icons/dark/gallery-empty.svg' : 'assets/icons/light/gallery-empty.svg'" alt="" />
<p class="title">{{ 'general.comingSoon.title' | transloco }}</p>
<p class="description">{{ 'general.comingSoon.description' | transloco }}</p>
